const sizes = {
  "program-tag-desktop": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    letterSpacing: "-0.3px",
    fontWeight: "bold",
    color: "white",
    padding: "0 32px 6px 0",
    borderBottom: "2px solid white",
    m: "0",
  },
  "program-tag-tablet": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    letterSpacing: "-0.3px",
    fontWeight: "bold",
    color: "white",
    padding: "0 32px 6px 0",
    borderBottom: "2px solid white",
    m: "0",
  },
  "program-tag-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "12px",
    letterSpacing: "-0.18px",
    fontWeight: "bold",
    color: "white",
    padding: "0 23px 6px 0",
    borderBottom: "1px solid white",
    m: "0",
  },
  "schedule-item-tag": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    letterSpacing: "-0.24px",
    fontWeight: 700,
    color: "white",
    padding: "0 32px 6px 0",
    borderBottom: "2px solid white",
    m: "0",
  },
  "schedule-item-tag-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "12px",
    letterSpacing: "-0.18px",
    fontWeight: "bold",
    color: "white",
    padding: "0 23px 6px 0",
    borderBottom: "1px solid white",
    m: "0",
  },
  "carousel-description": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "22px",
    letterSpacing: "-0.56px",
    lineHeight: "34px !important",
    color: "white",
    m: "0",
  },
  "carousel-description-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "12px",
    letterSpacing: "-0.28px",
    lineHeight: "17px !important",
    color: "white",
    m: "0",
  },
  "carousel-description-festival": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "22px",
    letterSpacing: "-0.56px",
    lineHeight: "34px !important",
    color: "white",
    m: "0",
  },
  "quotes-carousel-desktop": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "90px",
    letterSpacing: "-1.8px",
    lineHeight: "105px !important",
  },
  "quotes-carousel-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "32px",
    letterSpacing: "-1.8px",
    lineHeight: "45px !important",
  },
  "quotes-tag-tablet": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    letterSpacing: "-0.24px",
    fontWeight: "bold",
    padding: "10px 16px",
    border: "2px solid black",
    m: "0",
  },
  "quotes-tag-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "12px",
    letterSpacing: "-0.24px",
    fontWeight: "bold",
    padding: "6px 12px",
    border: "1px solid black",
    m: "0",
  },
  "quotes-carousel-source": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "400",
    fontSize: "35px",
    letterSpacing: "-0.7px",
    lineHeight: "95px !important",
    m: "0",
  },
  "quotes-carousel-source-mobile": {
    fontFamily: "Libre Franklin, sans-serif",
    fontWeight: "400",
    fontSize: "16px",
    letterSpacing: "-0.2px",
    m: "0",
  },
  "grid-card-label-desktop": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    letterSpacing: "-0.24px",
    color: "white",
    padding: "0 31px 7px 0",
    borderBottom: "2px solid white",
    m: "0",
  },
  "grid-card-label-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "12px",
    letterSpacing: "-0.18px",
    color: "white",
    padding: "0 28px 5px 0",
    borderBottom: "1px solid white",
    m: "0",
  },
  "grid-card-description": {
    fontFamily: "Libre Franklin",
    fontSize: "20px",
    fontWeight: 500,
    letterSpacing: "-0.4px",
    lineHeight: "24px !important",
    color: "white",
    m: "0",
  },
  "grid-card-description-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "-0.28px",
    lineHeight: "17px !important",
    color: "white",
    m: "0",
  },
  "countdown-bar-mobile": {
    fontFamily: "Libre Franklin",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: "-0.18px",
    color: "white",
  },
  "countdown-bar-desktop": {
    fontFamily: "Libre Franklin",
    fontSize: "16px",
    fontWeight: "bold",
    letterSpacing: "-0.9px",
    color: "white",
  },


  // Master DLS - Carl
  "alpha-desktop": {
    fontSize: "2rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "alpha-tablet": {
    fontSize: "2rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  // alpha is alpha-tablet
  "alpha": {
    fontSize: "2rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "alpha-mobile": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "2rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "bravo-desktop": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "2rem",
    color: "black"
  },
  "bravo-tablet": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    color: "black"
  },
  // bravo is bravo-tablet
  "bravo": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    color: "black"
  },
  "bravo-mobile": {
    fontSize: "1.125rem",
    fontWeight: "500",
    lineHeight: "1.475rem",
    color: "black"
  },
  "charlie-desktop": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    color: "black"
  },
  "charlie-tablet": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    color: "black"
  },
  // charlie is charlie-tablet
  "charlie": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    color: "black"
  },
  "charlie-mobile": {
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-desktop": {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-tablet": {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  // delta is delta-tablet
  "delta": {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-mobile": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    color: "black"
  },
  "echo-desktop": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "echo-tablet": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  // echo is echo-tablet
  "echo": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "echo-mobile": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    color: "black"
  },
  "label-desktop": {
    fontSize: "0.875rem",
    fontWeight: "500",
    lineHeight: "1.5rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "black"
  },
  "label-tablet": {
    fontSize: "0.875rem",
    fontWeight: "500",
    lineHeight: "1.5rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "black"
  },
  // label is label-tablet
  "label": {
    fontSize: "0.875rem",
    fontWeight: "500",
    lineHeight: "1.5rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "black"
  },
  "label-mobile": {
    fontSize: "0.625rem",
    fontWeight: "500",
    lineHeight: "0.875rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "black"
  },
  "caption-desktop": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "caption-tablet": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  // caption is caption-tablet
  "caption": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "caption-mobile": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "legal-desktop": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "legal-tablet": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  // legal is legal-tablet
  "legal": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "legal-mobile": {
    fontSize: "0.625rem",
    fontWeight: "400",
    lineHeight: "1.125rem",
    color: "black"
  },
  "copy-desktop": {
    fontSize: "1.25rem",
    fontWeight: "400",
    lineHeight: "1.875rem",
    color: "black"
  },
  "copy-tablet": {
    fontSize: "1.25rem",
    fontWeight: "400",
    lineHeight: "1.875rem",
    color: "black"
  },
  // copy is copy-tablet
  "copy": {
    fontSize: "1.25rem",
    fontWeight: "400",
    lineHeight: "1.875rem",
    color: "black"
  },
  "copy-mobile": {
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
}

export const Text = {
  sizes
}
